export default "__VITE_ASSET__52ad7a23__"